const Level6 = ({
  currentImage,
  L0OuterL2,
  L0OuterL3,
  L0OuterL4,
  L0OuterL5,
  L6Business,
  L6Core,
  L6Leadership,
  L6Self,
}) => {
  return (
    <div className={`${currentImage !== "imagedivl6" ? "hidden" : ""}`}>
      <div className="" id="imagedivl6">
        <div>
          <img
            src="assets/images/outerL6 1.png"
            useMap="#lw06"
            className="w-80 h-80"
            alt=""
          />
          <map name="lw06" id="lw06">
            <area
              className="cursor-pointer"
              alt="L6 Outer L2"
              onClick={L0OuterL2}
              coords="823,172,887,68,1021,148,1141,271,1211,418,1233,612,1101,616,1063,416,945,261"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Outer L3"
              onClick={L0OuterL3}
              coords="656,136,858,189,937,67,665,0,492,12,325,63,197,146,287,263,396,185,519,146"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Outer L4"
              onClick={L0OuterL4}
              coords="162,166,20,391,0,600,16,846,165,811,121,615,150,450,219,325,283,250,214,217"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Outer L5"
              onClick={L0OuterL5}
              coords="33,779,141,740,252,959,444,1079,614,1099,615,1220,413,1196,217,1094,132,1006,62,882"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Business"
              onClick={L6Business}
              coords="610,618,614,1099,774,1075,944,970,1060,798,1098,618"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Core"
              onClick={L6Core}
              coords="614,131,616,615,1098,615,1065,440,949,264,756,153"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Leadership"
              onClick={L6Leadership}
              coords="121,616,138,495,229,313,398,172,614,130,613,616,330,615"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L6 Self"
              onClick={L6Self}
              coords="120,615,610,617,614,1102,407,1063,256,955,165,815"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
};

export default Level6;
